(ns minorodata.file-ingest.subs
  (:require [re-frame.core :as re-frame]
            [clojure.string :as cstr]
            [applied-science.js-interop :as j]))


(re-frame/reg-sub
 :file-ingest.subs/ingest-tables-options
 (fn []
   (re-frame/subscribe [:ingest-tables/pull]))
 (fn [tables]
   (mapv (fn [t]
           {:value t
            :label t})
         (:ingest-tables/tables tables))))


(re-frame/reg-sub
 :file-ingest.subs/preview-data
 (fn []
   (re-frame/subscribe [:ingest-preview-data/pull]))
 (fn [data]
   (:ingest-preview-data/data data)))


(re-frame/reg-sub
 :file-ingest.subs/declared-headers
 (fn []
   (let [preview-data @(re-frame/subscribe [:file-ingest.subs/preview-data])
         first-row    (first preview-data)
         header-row   @(re-frame/subscribe [:ingest-header-row/pull])
         {:ingest-header-row/keys [header-idx]} header-row
         headers (if (nil? header-idx)
                   (->> first-row
                        (map-indexed (fn [i _]
                                       (str "column_" i)))
                        (into []))
                   first-row)]
     (map (fn [header] {:name header
                        :id   (random-uuid)})
          headers))))


(re-frame/reg-sub
 :file-ingest.subs/entire-sheet-data
 (fn []
   (re-frame/subscribe [:ingest-data/pull]))
 (fn [sheet-data]
   (let [{:ingest-data/keys [data]} sheet-data]
     (when (some? data)
       (j/get data :length)))))


(re-frame/reg-sub
 :file-ingest.subs/file-metadata
 (fn []
   (re-frame/subscribe [:ingest-file/pull]))
 (fn [{:ingest-file/keys [file-name sheet-names]}]
   {:file-type (-> file-name
                   (cstr/split #"\.")
                   last
                   cstr/upper-case)
    :file-name file-name
    :sheet-count (count sheet-names)}))


(re-frame/reg-sub
 :file-ingest.subs/sheet-metadata
 (fn []
   (let [rows (re-frame/subscribe [:ingest-data/pull])
         {:ingest-data/keys [data]} @rows]
     {:total-cols (-> data first count)
      :total-rows (j/get data :length)})))
